/* La Maison du Sac: suppress the malformed shipping-estimator block in the draft theme only. */
(function () {
  function hideMalformedShippingEstimator() {
    const all = Array.from(document.body ? document.body.querySelectorAll('*') : []);
    const candidates = all.filter(function (el) {
      if (!el || !el.isConnected || el.dataset.lmdsShippingFix === 'done') return false;
      const text = (el.innerText || el.textContent || '').replace(/\\s+/g, ' ').trim().toLowerCase();
      if (text.length < 25 || text.length > 900) return false;
      const hasShipping = text.includes('frais d') && text.includes('expédition');
      const hasRegion = text.includes('france métropolitaine');
      const hasEstimator = text.includes('pour le produit') || text.includes('livraison standard') || text.includes('mondial relay');
      return hasShipping && hasRegion && hasEstimator;
    });
    if (!candidates.length) return;
    candidates.sort(function (a, b) {
      return (a.innerText || a.textContent || '').length - (b.innerText || b.textContent || '').length;
    });
    const target = candidates[0];
    if (!target || target.matches('body, main, h1, h2, button')) return;
    target.dataset.lmdsShippingFix = 'done';
    target.style.setProperty('display', 'none', 'important');
  }
  function run() {
    hideMalformedShippingEstimator();
    const observer = new MutationObserver(hideMalformedShippingEstimator);
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () { observer.disconnect(); }, 20000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
